import React, { useState } from 'react';

const MapLegend = () => {
  const [hoveredItem, setHoveredItem] = useState(null);

  return (
    <div className="channel-map-legend">
      <div className="legend-item"
        onMouseEnter={() => setHoveredItem('commercial')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <img src={hoveredItem === 'commercial' ? '/red-pin.svg' : '/dark-blue-pin.svg'} alt="Commercial Channel" className="map-pin" />
        <span className="legend-text">Commercial Channel</span>
      </div>
      <div className="legend-item"
        onMouseEnter={() => setHoveredItem('academic')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <img src={hoveredItem === 'academic' ? '/orange-pin.svg' : '/black-pin.svg'} alt="Academic Channel" className="map-pin" />
        <span className="legend-text">Academic Channel</span>
      </div>
    </div>
  );
};

export default MapLegend; 